growingTextHandler = {
    $panelGrowingText = $('.panel-growing-text'),
    
    init = function(){
        var self = this;

        gsap.registerPlugin(ScrollTrigger);
        if ($('.hero-section').length > 0) {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: ".hero-section",//hero-outer-section",
                    start: "top top",
                    end: "bottom top",
                    scrub: true,
                    pin: ".hero-section",
                    //markers: true,
                },
                
            });
            tl.set(".grow-text", {
                fontSize: "100%",
            })
            tl.to(".grow-text", {
                fontSize: "190%",
                duration: 5, 
                ease: Power1.easeIn, 
            }, 5);
        }
            
    }
}